import React from 'react';
import {
  Form,
  Field,
  getIn,
  Formik,
  FieldArray,
} from 'formik';
import {
  withApi,
  withNotification,
} from 'wrappers';
import {
  TextBase,
  ButtonSave,
  DateTimePickerBase,
  ButtonCancel,
  GeneralPopover,
} from 'components';
import {
  Grid,
  Typography,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '@material-ui/core';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { messages } from 'constantes';
import endPoints from 'endPoints/endPoints';

const validationSchema = Yup.object({
  empresa: Yup.string().required('El campo es requerido'),
  nombre: Yup.string().required('El campo es requerido'),
  email: Yup.string()
    .email('El campo es inválido')
    .required('El campo es requerido'),
  cargo: Yup.string().required('El campo es requerido'),
  celular: Yup.string().required('El campo es requerido'),
  opciones: Yup.array().of(Yup.object().shape({
    fecha: Yup.date().required('El campo es requerido').nullable(),
  })),
});

const AgendarDemostracionForm = ({
  doPost,
  onClose,
  appSuccess,
  genericException,
}) => {
  const endPoint = endPoints.centroAyuda.procesos.agendarDemostracion;

  const state = {
    empresa: '',
    nombre: '',
    email: '',
    cargo: '',
    celular: '',
    opciones: [
      { fecha: null },
      { fecha: null },
      { fecha: null },
    ],
  };

  const mapValues = (values) => {
    const {
      email,
      cargo,
      nombre,
      empresa,
      celular,
      opciones,
    } = values;

    return {
      email,
      cargo,
      celular,
      opciones,
      nombre: nombre.toUpperCase(),
      empresa: empresa.toUpperCase(),
    };
  };

  const onSubmit = async (formValues) => {
    const url = endPoint.base;
    const data = mapValues(formValues);
    try {
      await doPost({ url, data });
      appSuccess(messages.crud.new);
      onClose();
    } catch (e) {
      genericException(e);
    }
  };

  return (
    <>
      <DialogTitle>
        AGENDAR DEMOSTRACIÓN
      </DialogTitle>
      <Formik
        enableReinitialize
        initialValues={state}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({ values, touched, errors }) => (
          <Form>
            <DialogContent>
              <Grid container direction="row" spacing={2}>
                <Grid
                  item
                  xs={12}
                  md={12}
                  xl={12}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <Field
                    label="Empresa"
                    name="empresa"
                    component={TextBase}
                  />
                  <GeneralPopover
                    message="Empresa de la cual se comunica"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={12}
                  xl={12}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <Field
                    label="Nombre"
                    name="nombre"
                    component={TextBase}
                  />
                  <GeneralPopover
                    message="Nombre de la persona que requiere la demostración"
                  />
                </Grid>
                <Grid item xs={12} md={12} xl={12}>
                  <Field
                    label="Email"
                    name="email"
                    component={TextBase}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={12}
                  xl={12}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <Field
                    label="Cargo"
                    name="cargo"
                    component={TextBase}
                  />
                  <GeneralPopover
                    message="Cargo de la persona que requiere la demostración"
                  />
                </Grid>
                <Grid item xs={12} md={12} xl={12}>
                  <Field
                    label="Celular"
                    name="celular"
                    component={TextBase}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={12}
                  xl={12}
                  style={{ display: 'flex', marginLeft: 5 }}
                >
                  <FieldArray key="field-array" name="opciones">
                    {() => (
                      <>
                        <Grid container direction="row" spacing={2}>
                          {values.opciones.map((item, i) => {
                            const fecha = `opciones[${i}].fecha`;
                            const touchedFecha = getIn(touched, fecha);
                            const errorFecha = getIn(errors, fecha);

                            return (
                              <>
                                <Typography variant="h5" style={{ marginLeft: 15 }}>
                                  {`opción: ${i + 1}`}
                                </Typography>
                                <Grid key={`grid1-${String(i)}`} item xs={12} md={12} xl={12}>
                                  <Field
                                    key={`fecha-${String(i)}`}
                                    label="Fecha - Hora"
                                    name={fecha}
                                    helperText={
                                    touchedFecha && errorFecha
                                      ? errorFecha
                                      : ''
                                  }
                                    error={Boolean(touchedFecha && errorFecha)}
                                    component={DateTimePickerBase}
                                  />
                                  <GeneralPopover
                                    message="Indique la opción de disponibilidad para la demostración"
                                  />
                                </Grid>
                              </>
                            );
                          })}
                        </Grid>
                      </>
                    )}

                  </FieldArray>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <ButtonCancel onClick={onClose} />
              <ButtonSave label="Guardar" />
            </DialogActions>
          </Form>
        )}
      </Formik>
    </>
  );
};

AgendarDemostracionForm.propTypes = {
  doPost: PropTypes.func,
  appSuccess: PropTypes.func,
  genericException: PropTypes.func,
  onClose: PropTypes.func,
};

export default withApi(withNotification(AgendarDemostracionForm));
